import { render, staticRenderFns } from "./details.vue?vue&type=template&id=94a247c0"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./details.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsUiLoader: require('/home/node/app/components/elements/ui-loader/ui-loader.vue').default,TemplatesFaqDetails: require('/home/node/app/components/templates/faq-details/faq-details.vue').default})
